export default {
  common: {
    totalPrefix: "共計",
    totalSuffix: "條數據",
    download: "下載",
    loading: "拼命加載中",
    empty: "暫無數據",
    downloadFilename: "數據明細",
  },
  columns: {
    action: "操作",
    client: "客戶端",
    state: "狀態",
    updateTime: "更新時間",
    paymentMethod: "收款方式",
    paymentDetail: "收款詳情",
    bankCard: "銀行卡號/賬號",
    bankBranch: "銀行支行",
    bankName: "銀行名稱",
  },
};
